import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskModule } from 'ngx-mask';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { ViggoCoreComponentsModule } from 'viggo-sistemas-core-web';
import { AutocompletePedidosContasComponent } from './components/autocomplete-contas-pedidos/autocomplete-contas-pedidos.component';
import { FastAutocompleteMateriaVariacoesComponent } from './components/autocomplete-materia-variacoes/autocomplete-materia-variacoes.component';
import { AutocompletePedidosTpeComponent } from './components/autocomplete-pedidos-disponiveis/autocomplete-pedidos-disponiveis.component';
import { AutocompletePedidosExpedicaoComponent } from './components/autocomplete-pedidos-expedicao/autocomplete-pedidos-expedicao.component';
import { FastAutocompleteProdutoVariacoesComponent } from './components/autocomplete-produto-variacoes/autocomplete-produto-variacoes.component';
import { AutocompleteProdutosTpeComponent } from './components/autocomplete-produtos-disponiveis/autocomplete-produtos-disponiveis.component';
import { AutoCompleteUsers } from './components/autocomplete-users/autocomplete-users.component';
import { FastAutocompleteVariacoesComponent } from './components/autocomplete-variacoes/autocomplete-variacoes.component';
import { ChipInputComponent } from './components/chip-input/chip-input.component';
import { ClientesCarteiraAutoComplete } from './components/clientes_carteira/clientes_carteira.component';
import { DialogDelContatoComponent } from './components/dialog-del-contato/dialog-del-contato.component';
import { DialogEditContatoComponent } from './components/dialog-edit-contato/dialog-edit-contato.component';
import { FastAppHeaderComponent } from './components/fast-app-header/fast-app-header.component';
import { FastAutocompleteComponent } from './components/fast-autocomplete/fast-autocomplete.component';
import { FastCategoriaMateriaPrimaComponent } from './components/fast-categoria-materia-prima/fast-categoria-materia-prima.component';
import { FastCategoriaProdutoComponent } from './components/fast-categoria-produto/fast-categoria-produto.component';
import { FastCategoriaServicosComponent } from './components/fast-categoria-servico/fast-categoria-servico.component';
import { FastCentroResultadoComponent } from './components/fast-centro-resultado/fast-centro-resultado.component';
import { FastClienteComponent } from './components/fast-cliente/fast-cliente.component';
import { FastCombustivelComponent } from './components/fast-combustivel/fast-combustivel.component';
import { FastCondPgmtComponent } from './components/fast-cond-pgmt/fast-cond-pgmt.component';
import { FastContatoComponent } from './components/fast-contato/fast-contato.component';
import { FastDepositoComponent } from './components/fast-deposito/fast-deposito.component';
import { FastEnderecoComponent } from './components/fast-endereco/fast-endereco.component';
import { FastFabricanteComponent } from './components/fast-fabricante/fast-fabricante.component';
import { FastFormaPgmtComponent } from './components/fast-forma-pgmt/fast-forma-pgmt.component';
import { FastFornecedorComponent } from './components/fast-fornecedor/fast-fornecedor.component';
import { FastInstituicaoComponent } from './components/fast-instituicao/fast-instituicao.component';
import { FastMarcaComponent } from './components/fast-marca/fast-marca.component';
import { FastMateriaPrimaComponent } from './components/fast-materia-prima/fast-materia-prima.component';
import { FastModeloTransporteComponent } from './components/fast-modelo-transporte/fast-modelo-transporte.component';
import { FastModelosComponent } from './components/fast-modelo/fast-modelo.component';
import { FastMotoristaComponent } from './components/fast-motorista/fast-motorista.component';
import { FastNaturezaFinanceiraComponent } from './components/fast-natureza-financeira/fast-natureza-financeira.component';
import { FastParceiroComponent } from './components/fast-parceiro/fast-parceiro.component';
import { FastPortadorComponent } from './components/fast-portador/fast-portador.component';
import { FastPrecoProdutoComponent } from './components/fast-preco-produto/fast-preco-produto.component';
import { AppFormProdutoVariacoesComponent } from './components/fast-produto/components/app-form-produto-variacoes/app-form-produto-variacoes.component';
import { AppTableProdutosVariacaoComponent } from './components/fast-produto/components/table-produto-variacoes/app-table-produto-variacoes.component';
import { FastProdutoComponent } from './components/fast-produto/fast-produto.component';
import { FastProprietarioVeiculoComponent } from './components/fast-proprietario-veiculo/fast-proprietario-veiculo.component';
import { FastServicosComponent } from './components/fast-servico/fast-servico.component';
import { FastTabelaComponent } from './components/fast-tabela/fast-tabela.component';
import { FastTipoServicoCorreioComponent } from './components/fast-tipo-servico-correio/fast-tipo-servico-correio.component';
import { FastVariacaoMateriaComponent } from './components/fast-variacao-materia/fast-variacao-materia.component';
import { FastVariacaoProdutoComponent } from './components/fast-variacao-produto/fast-variacao-produto.component';
import { FastVeiculoComponent } from './components/fast-veiculo/fast-veiculo.component';
import { FastFormInformacoesPessoaisComponent } from './components/fast-vendedor/components/fast-form-info-pessoais/fast-form-info-pessoais.component';
import { FastVendedorComponent } from './components/fast-vendedor/fast-vendedor.component';
import { AcabamentosDisponiveisAutoComplete } from './components/gerenciar-acabamentos-disponiveis/gerenciar-acabamentos-disponiveis.component';
import { DependenciasAutoComplete } from './components/gerenciar-dependencias/gerenciar_dependencias_etapas.component';
import { ParteEtapasDisponiveisAutoComplete } from './components/gerenciar-etapas-disponiveis-parte/gerenciar_etapas_disponiveis_parte.component';
import { EtapasDisponiveisAutoComplete } from './components/gerenciar-etapas-disponiveis/gerenciar_etapas_disponiveis.component';
import { GerenciarLinhasProducaoDisponiveisAutoComplete } from './components/gerenciar-linhas-producao/gerenciar_linhas_producao.component';
import { MateriaisDisponiveisAutoComplete } from './components/gerenciar-materiais-disponiveis/gerenciar-materiais-disponiveis.component';
import { OrcamentoMateriaisDisponiveisAutoComplete } from './components/gerenciar-orcamento-materiais-disponiveis/gerenciar-orcamento-materiais-disponiveis.component';
import { ProcessosDisponiveisAutoComplete } from './components/gerenciar-processos-disponiveis/gerenciar_processos_disponiveis.component';
import { ModeloMateriaisDisponiveisAutoComplete } from './components/modelo-materiais-disponiveis/modelo-materiais-disponiveis.component';
import { PecasModeloAutoComplete } from './components/pecas_modelo/pecas_modelo.component';
import { PedidoProcessosDisponiveisAutoComplete } from './components/processos-disponiveis-pedido/processos-disponiveis-pedido.component';
import { TpfMateriaisDisponiveisAutoComplete } from './components/tpf-materiais-disponiveis/tpf-materiais-disponiveis.component';
import { VendedorTpfDisponiveisAutoComplete } from './components/vendedor-tpf-disponiveis/vendedor-tpf-disponiveis.component';
import { FastFormatCpfCnpjDirective } from './directive/fast-cpf_cnpj.directive';
import { FastFormatDataDirective } from './directive/fast-date.directive';
import { FastHeaderFormatDirective } from './directive/fast-header.directive';

@NgModule({
  declarations: [
    FastClienteComponent,
    ChipInputComponent,
    FastMateriaPrimaComponent,
    FastEnderecoComponent,
    FastAutocompleteComponent,
    FastServicosComponent,
    FastFornecedorComponent,
    FastParceiroComponent,
    FastContatoComponent,
    DialogEditContatoComponent,
    DialogDelContatoComponent,
    FastModelosComponent,
    FastFormatDataDirective,
    FastAppHeaderComponent,
    FastHeaderFormatDirective,
    FastFormatCpfCnpjDirective,
    ClientesCarteiraAutoComplete,
    PecasModeloAutoComplete,
    DependenciasAutoComplete,
    EtapasDisponiveisAutoComplete,
    ParteEtapasDisponiveisAutoComplete,
    GerenciarLinhasProducaoDisponiveisAutoComplete,
    PedidoProcessosDisponiveisAutoComplete,
    MateriaisDisponiveisAutoComplete,
    AcabamentosDisponiveisAutoComplete,
    ProcessosDisponiveisAutoComplete,
    ModeloMateriaisDisponiveisAutoComplete,
    FastCategoriaProdutoComponent,
    FastFabricanteComponent,
    FastTabelaComponent,
    FastVariacaoProdutoComponent,
    FastAutocompleteVariacoesComponent,
    FastAutocompleteProdutoVariacoesComponent,
    AppTableProdutosVariacaoComponent,
    AppFormProdutoVariacoesComponent,
    FastPrecoProdutoComponent,
    FastProdutoComponent,
    FastCategoriaServicosComponent,
    FastCategoriaMateriaPrimaComponent,
    FastFormaPgmtComponent,
    FastCondPgmtComponent,
    FastInstituicaoComponent,
    FastVariacaoMateriaComponent,
    FastAutocompleteMateriaVariacoesComponent,
    AutocompletePedidosTpeComponent,
    FastCombustivelComponent,
    FastTipoServicoCorreioComponent,
    FastMarcaComponent,
    FastProprietarioVeiculoComponent,
    FastCentroResultadoComponent,
    FastNaturezaFinanceiraComponent,
    FastModeloTransporteComponent,
    FastMotoristaComponent,
    FastVeiculoComponent,
    AutocompletePedidosExpedicaoComponent,
    FastPortadorComponent,
    FastVendedorComponent,
    FastFormInformacoesPessoaisComponent,
    AutoCompleteUsers,
    AutocompletePedidosContasComponent,
    AutocompleteProdutosTpeComponent,
    OrcamentoMateriaisDisponiveisAutoComplete,
    TpfMateriaisDisponiveisAutoComplete,
    VendedorTpfDisponiveisAutoComplete,
    FastDepositoComponent
  ],
  imports: [
    CommonModule,
    NgxMaskModule.forChild(),
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatTabsModule,
    MatButtonModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    ViggoCoreComponentsModule,
    MatCheckboxModule,
    MatDividerModule,
    MatListModule,
    MatIconModule,
    MatChipsModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatTableModule,
    MatTooltipModule,
    // primeng modules
    AutoCompleteModule,
    InputTextModule,
    InputTextareaModule,
    InputNumberModule,
    RippleModule,
    ButtonModule,
    StyleClassModule,
    InputMaskModule,
    TableModule,
    DropdownModule,
    ProgressSpinnerModule,
    DialogModule,
    InputGroupModule,
    InputGroupAddonModule,
    TooltipModule
  ],
  exports: [
    FastAutocompleteComponent,
    ClientesCarteiraAutoComplete,
    PecasModeloAutoComplete,
    DependenciasAutoComplete,
    EtapasDisponiveisAutoComplete,
    ParteEtapasDisponiveisAutoComplete,
    GerenciarLinhasProducaoDisponiveisAutoComplete,
    PedidoProcessosDisponiveisAutoComplete,
    MateriaisDisponiveisAutoComplete,
    AcabamentosDisponiveisAutoComplete,
    ProcessosDisponiveisAutoComplete,
    ModeloMateriaisDisponiveisAutoComplete,
    FastCategoriaProdutoComponent,
    FastFabricanteComponent,
    FastTabelaComponent,
    FastAutocompleteVariacoesComponent,
    FastAutocompleteProdutoVariacoesComponent,
    FastFormaPgmtComponent,
    FastCondPgmtComponent,
    FastInstituicaoComponent,
    FastVariacaoMateriaComponent,
    FastAutocompleteMateriaVariacoesComponent,
    AutocompletePedidosTpeComponent,
    FastCombustivelComponent,
    FastTipoServicoCorreioComponent,
    FastMarcaComponent,
    FastProprietarioVeiculoComponent,
    FastCentroResultadoComponent,
    FastNaturezaFinanceiraComponent,
    FastModeloTransporteComponent,
    FastMotoristaComponent,
    FastVeiculoComponent,
    AutocompletePedidosExpedicaoComponent,
    FastPortadorComponent,
    FastVendedorComponent,
    AutoCompleteUsers,
    AutocompletePedidosContasComponent,
    AutocompleteProdutosTpeComponent,
    OrcamentoMateriaisDisponiveisAutoComplete,
    TpfMateriaisDisponiveisAutoComplete,
    VendedorTpfDisponiveisAutoComplete
  ]
})
export class FastCadastroModule {}
